<template>
    <div class="comments">
        <h3>{{ commentsLength }} {{ commentsText }}</h3>

        <div v-for="comment in comments" class="comment">
            <div class="comment__avatar">
                <avatar :user="comment.user"></avatar>
            </div>
            <div class="comment__content">
                <strong>{{ comment.user.name }}</strong> - <span class="date">{{ formatDate(comment.created_at) }}</span>
                <div v-html="comment.content"></div>
            </div>
        </div>

        <div class="comment">
            <div class="comment__avatar">
                <avatar :user="comment.user"></avatar>
            </div>
            <div class="comment__content">
                <editor class="comments__create" placeholder="Add a comment" v-model="comment.content" :comment="true" v-on:add-comment="saveComment"></editor>
            </div>
        </div>

    </div>
</template>

<script>
    import { format, parse } from 'date-fns';
    export default {
        props: ['comments', 'commentsCount'],
        data(){
            return {
                createCommentURL: '/api/groups/' + this.$route.params.group + "/posts/" + this.$route.params.post + "/comments",
                comment:{
                    content: ""
                }
            }
        },
        computed: {
            commentsText(){
                if( this.commentsCount == 1){
                    return 'comment';
                }else{
                    return 'comments';
                }
            },
            commentsLength(){
                return (this.comments) ? this.comments.length : 0 ;
            }
        },
        created() {
            
        },
        methods: {
            formatDate(date){
                if(date){
                    date = parse(date, 'yyyy-MM-dd HH:mm:ss', new Date());
                    return format(date, 'do LLL yyyy HH:mm');
                }
            },
            saveComment(editor){
                axios.post(this.createCommentURL, this.comment).then((response) => {
                    this.comment.content = "";
                    this.comments.push(response.data);
                }, (response) => {
                    this.error = response;
                });
            }
        }
    }
</script>